<template>
    <div class="page bg-gray pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="content">
            <div class="card">
                <div class="pd-020">
                    <div class="input-field bd-bot click" @click="showPop = true">
                        <div class="fs-32 color-333 left required">开户银行 </div>
                        <div class="field-content" :class="formItem.bankName ? 'color-333':'color-999'">{{formItem.bankName || '请选择开户银行'}}</div>
                        <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">账号名称</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.bankUname" placeholder="请输入账号名称" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">银行账户</div>
                        <van-field class="input" type="digit" :clearable="true" v-model="formItem.bankNo" placeholder="请输入银行账户" />
                    </div>
                    <div class="input-field">
                        <div class="fs-32 color-333 left required">开户行地址</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.bankAddress" placeholder="请输入开户行地址" />
                    </div>
<!--                    <div class="input-field">-->
<!--                        <div class="fs-32 color-333 left required">账户 <br/>结算周期</div>-->
<!--                        <van-radio-group  class="input" v-model="formItem.clearingCycle">-->
<!--                            <van-radio name="1">T+1</van-radio>-->
<!--                            <van-radio name="7">T+7</van-radio>-->
<!--                        </van-radio-group>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
        <div class="fixed-bot">
            <div class="btn click" @click="submitForm()">保存</div>
        </div>

        <van-popup v-model="showPop" position="bottom">
            <van-picker show-toolbar :columns="dicts['bank_code']" value-key="codename"  @cancel="showPop = false" @confirm="onConfirm"  />
        </van-popup>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qryShopDetail,saveMallShopInfo} from "@/api/shop"
    import initDict from "@/mixins/initDict"
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "bankInfo",
        components:{backTitleBar},
        mixins:[initDict,inputFix],
        data(){
            return{
                formItem:{},
                showPop:false,
                shopId:this.$store.state.user.shopId,
            }
        },
        created(){
            // 加载数据字典
            let codeList = [
                'bank_code',
            ]
            this.getThisDict(codeList)
            this.getDetail();
        },
        methods:{

            //获取商家详情
            getDetail(){
                qryShopDetail(this.shopId).then(res=>{
                    // res.data.clearingCycle = String(res.data.clearingCycle)
                    this.formItem = res.data;
                })
            },

            onConfirm(value){
                this.$set(this.formItem,'bankCode',value.code);
                this.$set(this.formItem,'bankName',value.codename);
                this.showPop = false;
            },
            submitForm(){
                let form = this.formItem
                if(!form.bankName || !form.bankUname || !form.bankNo || !form.bankAddress){
                    this.$toast("请填写必填项目");
                    return
                }
                let params = {
                    bankName: form.bankName,
                    bankUname: form.bankUname,
                    bankNo: form.bankNo,
                    bankAddress: form.bankAddress,
                    shopName: form.shopName,
                    // clearingCycle:form.clearingCycle,
                    shopId:form.shopId
                }
                saveMallShopInfo(params).then(res=>{
                    if(res.code == 0){
                        this.$toast("保存成功");
                        this.$router.back();
                    }

                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .content{
        padding: .2rem .24rem;
    }
    .van-radio{
        margin-bottom: .1rem;
        &:last-child{
            margin-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// bankInfo.vue?7d4b5fe0